import React,{useState} from 'react';
import {useParams} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {
  appendLog,loadContacts,loadDeliveries,loadRegistrations,loadSessions,loadWebinars,
  save,scheduleForRegistration,scoreContact
} from '../storage';

const initial={
  name:'',company:'',title:'',email:'',phone:'',customers:'',opportunities:'',
  intent:'',purpose:'',privacyConsent:false,marketingConsent:false
};

function Done({name,onAgain}) {
  return <div className="public-success">
    <span><SafeIcon icon={FiIcons.FiCheck} /></span>
    <h1>お申し込みを受け付けました</h1>
    <p>{name} 様、お申し込みありがとうございます。<br />
      確認メールは送信されていません。開催回に申込履歴を保存しました。</p>
    <button className="secondary-button" onClick={onAgain}>申込フォームに戻る</button>
    <a href="/">管理画面へ</a>
  </div>;
}

export default function PublicForm() {
  const {sessionId}=useParams();
  const sessions=loadSessions();
  const session=sessionId
    ? sessions.find(item=>item.id===sessionId)
    : sessions.find(item=>item.status==='受付中');
  const webinar=loadWebinars().find(item=>item.id===session?.webinarId);
  const [form,setForm]=useState(initial);
  const [done,setDone]=useState(false);
  const [error,setError]=useState('');
  const set=(key,value)=>setForm(current=>({...current,[key]:value}));

  const submit=event=>{
    event.preventDefault();
    setError('');
    if (!session || session.status!=='受付中') {
      setError('この開催回は現在申込受付中ではありません。');
      return;
    }
    const email=form.email.trim().toLowerCase();
    if (!email.endsWith('@example.jp')) {
      setError('デモ環境では、架空のメールアドレス（例：sample@example.jp）のみ登録できます。');
      return;
    }
    const registrations=loadRegistrations();
    const contacts=loadContacts();
    const duplicate=registrations.some(item=>{
      if (item.sessionId!==session.id) return false;
      return contacts.find(contact=>contact.id===item.contactId)?.email.trim().toLowerCase()===email;
    });
    if (duplicate) {
      setError('この開催回にはすでに同じメールアドレスで申込済みです。');
      return;
    }

    const existing=contacts.find(contact=>contact.email.trim().toLowerCase()===email);
    const now=new Date().toISOString();
    const contact=existing ? {...existing} : {
      ...form,id:`contact-${Date.now()}`,isDemo:true,score:0,rank:'C',
      attendance:'未確認',materials:false,
      emailStatus:form.marketingConsent ? '配信可能' : '停止',
      partner:'未登録',meeting:'未予約',opportunity:'未作成',
      lastTouch:now,nextAction:'申込内容を確認',history:[]
    };
    Object.assign(contact,{
      name:form.name.trim(),company:form.company.trim(),title:form.title.trim(),
      email,phone:form.phone.trim(),customers:form.customers,opportunities:form.opportunities,
      intent:form.intent,purpose:form.purpose,lastTouch:now,
      history:[...(contact.history || []),{
        at:now,text:`「${webinar?.name || 'ウェビナー'}」の開催回に申込（${session.id}）`
      }]
    });
    if (form.marketingConsent) contact.emailStatus='配信可能';
    Object.assign(contact,scoreContact(contact));

    const updatedContacts=existing
      ? contacts.map(item=>item.id===contact.id ? contact : item)
      : [contact,...contacts];
    const registration={
      id:`registration-${Date.now()}`,contactId:contact.id,sessionId:session.id,
      attendance:'未確認',materials:false,survey:null,createdAt:now,isDemo:true,
      privacyConsent:form.privacyConsent,marketingConsent:form.marketingConsent,
      emailStatus:form.marketingConsent ? '配信可能' : '停止',
      meeting:'未予約',partner:'未登録',opportunity:'未作成'
    };
    save('awsa_contacts',updatedContacts);
    save('awsa_registrations',[registration,...registrations]);
    save('awsa_deliveries',scheduleForRegistration(registration,session,loadDeliveries()));
    save('awsa_logs',appendLog(
      JSON.parse(localStorage.getItem('awsa_logs') || '[]'),
      'フォーム送信',`${contact.company} / ${contact.name} / ${session.id}（デモ登録・メール未送信）`
    ));
    setDone(true);
  };

  if (!session || !webinar) return <div className="public-page"><div className="public-success">
    <h1>この開催回は見つかりません</h1><p>開催回のURLをご確認ください。</p><a href="/">管理画面へ</a>
  </div></div>;
  if (done) return <div className="public-page"><Done name={form.name} onAgain={()=>{setForm(initial);setDone(false);}} /></div>;

  return <div className="public-page">
    <div className="public-brand"><span className="brand-mark"><SafeIcon icon={FiIcons.FiZap} /></span>
      <b>WebinarFlow</b><span>PARTNER WEBINAR</span></div>
    <main className="public-card">
      <div className="public-cover"><span>PARTNER GROWTH SESSION</span><h1>{webinar.name}</h1>
        <p>{webinar.description}</p>
        <div className="public-event-meta">
          <span><SafeIcon icon={FiIcons.FiCalendar} />{new Date(session.date).toLocaleString('ja-JP',{
            timeZone:'Asia/Tokyo',year:'numeric',month:'long',day:'numeric',hour:'2-digit',minute:'2-digit'
          })}</span>
          <span><SafeIcon icon={FiIcons.FiGift} />参加特典：{webinar.bonus || '提案ガイド'}</span>
        </div>
      </div>
      {session.status==='受付中' ? <form className="public-form" onSubmit={submit}>
        <div className="notice-banner warning-banner">
          <SafeIcon icon={FiIcons.FiInfo} />
          <span>デモ専用フォームです。架空のテスト情報のみ入力してください。保存先はこのブラウザーで、メール送信は行いません。</span>
        </div>
        <div className="form-intro"><div><h2>この開催回に申し込む</h2>
          <p>必要事項をご入力ください。<b>*</b>は必須項目です。</p></div><span>開催回別受付</span></div>
        {error && <div className="form-error"><SafeIcon icon={FiIcons.FiAlertCircle} />{error}</div>}
        <div className="form-two">
          <label>氏名 <b>*</b><input required maxLength="80" value={form.name} onChange={event=>set('name',event.target.value)} /></label>
          <label>会社名 <b>*</b><input required maxLength="120" value={form.company} onChange={event=>set('company',event.target.value)} /></label>
        </div>
        <div className="form-two">
          <label>役職<input maxLength="80" value={form.title} onChange={event=>set('title',event.target.value)} /></label>
          <label>メールアドレス <b>*</b><input required type="email" maxLength="254"
            placeholder="sample@example.jp" value={form.email} onChange={event=>set('email',event.target.value)} /></label>
        </div>
        <div className="form-two">
          <label>電話番号<input type="tel" maxLength="30" value={form.phone} onChange={event=>set('phone',event.target.value)} /></label>
          <label>既存法人顧客数<input type="number" min="0" max="100000" value={form.customers} onChange={event=>set('customers',event.target.value)} /></label>
        </div>
        <label>月間商談機会数<input type="number" min="0" max="100000" value={form.opportunities} onChange={event=>set('opportunities',event.target.value)} /></label>
        <label>CRM/SFAの提案予定<select value={form.intent} onChange={event=>set('intent',event.target.value)}>
          <option value="">選択してください</option><option>具体的に提案したい</option>
          <option>提案を検討中</option><option>情報収集したい</option>
        </select></label>
        <label>今回の参加目的<textarea required maxLength="1000" rows="3"
          value={form.purpose} onChange={event=>set('purpose',event.target.value)} /></label>
        <div className="consent-box">
          <label className="checkbox-line"><input type="checkbox" required checked={form.privacyConsent}
            onChange={event=>set('privacyConsent',event.target.checked)} />個人情報の利用目的に同意します。<b>*</b></label>
          <p>デモ申込管理・ウェビナー運営の画面検証に利用します。<a href="#privacy">プライバシーポリシー</a></p>
          <label className="checkbox-line"><input type="checkbox" checked={form.marketingConsent}
            onChange={event=>set('marketingConsent',event.target.checked)} />今後の案内メールを受け取る（任意）</label>
        </div>
        <button className="primary-button submit-button" type="submit">無料で申し込む <SafeIcon icon={FiIcons.FiArrowRight} /></button>
        <p className="form-footnote"><SafeIcon icon={FiIcons.FiLock} />テスト登録のみ。確認メールや販促メールは送信されません。</p>
      </form> : <div className="public-form"><p className="muted-copy">この開催回は申込受付を行っていません（{session.status}）。</p></div>}
    </main>
    <footer className="public-footer">© 2025 WebinarFlow <span>デモ用申込フォーム</span></footer>
  </div>;
}
